const STABLE_ACHIEVEMENTS = {
  ACHIEVEMENT_BEAST_MASTER: {
    masterAchievement: 'beastMasterName',
    masterNotificationType: 'ACHIEVEMENT_STABLE',
  },
  ACHIEVEMENT_MOUNT_MASTER: {
    masterAchievement: 'mountMasterName',
    masterNotificationType: 'ACHIEVEMENT_STABLE',
  },
  ACHIEVEMENT_TRIAD_BINGO: {
    masterAchievement: 'triadBingoName',
    masterNotificationType: 'ACHIEVEMENT_STABLE',
  },
};

export default STABLE_ACHIEVEMENTS;
